import type { RosterLevelType } from '@wwe-portal/entities/roster.type';

import goldStar from '@wwe-portal/ui/public/assets/images/roster/star/gold.webp';
import bronzeStar from '@wwe-portal/ui/public/assets/images/roster/star/bronze.webp';
import silverStar from '@wwe-portal/ui/public/assets/images/roster/star/silver.webp';

import fullGoldStar from '@wwe-portal/ui/public/assets/images/roster/star/gold-6.png';
import fullBronzeStar from '@wwe-portal/ui/public/assets/images/roster/star/bronze-6.png';
import fullSilverStar from '@wwe-portal/ui/public/assets/images/roster/star/silver-6.png';

import hollowGoldStar from '@wwe-portal/ui/public/assets/images/roster/star/gold-hollow.png';
import hollowBronzeStar from '@wwe-portal/ui/public/assets/images/roster/star/bronze-hollow.png';
import hollowSilverStar from '@wwe-portal/ui/public/assets/images/roster/star/silver-hollow.png';

import hollowGoldStar6 from '@wwe-portal/ui/public/assets/images/roster/star/gold-6-hollow.png';
import hollowBronzeStar6 from '@wwe-portal/ui/public/assets/images/roster/star/bronze-6-hollow.png';
import hollowSilverStar6 from '@wwe-portal/ui/public/assets/images/roster/star/silver-6-hollow.png';

interface LevelStarProps {
  size?: number;
  level: RosterLevelType;
  className?: string;
}

const srcByLevel = {
  B: bronzeStar,
  S: silverStar,
  G: goldStar,
} as const;

const fullSrcByLevel = {
  B: fullBronzeStar,
  S: fullSilverStar,
  G: fullGoldStar,
} as const;

const hollowSrcByLevel = {
  B: hollowBronzeStar,
  S: hollowSilverStar,
  G: hollowGoldStar,
} as const;

const hollowFullSrcByLevel = {
  B: hollowBronzeStar6,
  S: hollowSilverStar6,
  G: hollowGoldStar6,
} as const;

export const LevelStar = ({ size, level, className }: LevelStarProps) => {
  return (
    <img
      src={srcByLevel[level]}
      className={className}
      height={size}
      width={size}
      alt={`${level} star`}
    />
  );
};

export const FullLevelStar = ({ size, level, className }: LevelStarProps) => {
  return (
    <img
      src={fullSrcByLevel[level]}
      className={className}
      height={size}
      width={size}
      alt={`6 ${level} star`}
    />
  );
};

export const HollowFullLevelStar = ({
  size,
  level,
  className,
}: LevelStarProps) => {
  return (
    <img
      src={hollowFullSrcByLevel[level]}
      className={className}
      height={size}
      width={size}
      alt={`6 ${level} star`}
    />
  );
};

export const HollowLevelStar = ({ size, level, className }: LevelStarProps) => {
  return (
    <img
      src={hollowSrcByLevel[level]}
      className={className}
      height={size}
      width={size}
      alt={`${level} star`}
    />
  );
};
